import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import DownloadPage from './pages/DownloadPage';
import FileUploadPage from './pages/FileUpload';
import TokenManagerPage from './pages/TokenManager';
import SyncFilesPage from './pages/SyncFiles';
import DocumentList from './components/DocumentList';
import PrivateRoute from './components/PrivateRoute';

const PrivateLayout = () => {
  return (
    <PrivateRoute>
      <Layout>
        <Outlet />
      </Layout>
    </PrivateRoute>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route element={<PrivateLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/upload" element={<FileUploadPage />} />
            <Route path="/tokens" element={<TokenManagerPage />} />
            <Route path="/sync" element={<SyncFilesPage />} />
            <Route path="/documents/:groupId" element={<DocumentList />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
